export default __webpack_public_path__ + "static/media/work-bee.5b676c0a.png";